import "./BenefitsSectionPlan.css";
import AcceleratedIcon from "../../Assets/Images/accelerate-benefit-icon.svg";
import AutomaticIcon from "../../Assets/Images/automatic-benefit-icon.svg";
import { useTranslation } from "../../Hooks/useTranslation";
import coverImage from "../../Assets/Images/Frame 1321315765.png";

const BenefitSectionPlanPage2 = ({ titleText, price, sectionRef }) => {
  const translations = useTranslation();
  return (
    <div
      id="terms-benefits"
      className="item2 benefits-section-layout py-12 lg:py-32 overflow-hidden"
    >
      <div className="container">
        <div className="flex flex-col lg:flex-row gap-8 items-start">
          {/* Left text column */}
          <div className="w-full lg:w-2/5">
            <div className="hidden lg:block reveal-up mb-[211px] [@media(min-width:1920px)]:mb-[240px]">
              <div className="text-sm md:text-[10.5px] md:leading-[14.7px] xl:text-sm xl:leading-normal text-gray-600 mb-1 learnmoreacc">
                {translations.select_term}
              </div>
              <div className="text-[40px] leading-[44px] md:text-[30px] md:leading-[33px] xl:text-[40px] xl:leading-[44px] tracking-tight extra-title-heading">
                <span className="font-semibold">
                  {translations.main_benefits}
                </span>{" "}
                {translations.of_the_policy}
              </div>
            </div>
            <div>
              <div className="flex pb-[2.5rem] reveal-up reveal-delay-2 benefits-policy-grid">
                <div className="pe-[1.8rem] flex-none">
                  <img src={AcceleratedIcon} className="w-[84px]" alt="" />
                </div>
                <div className="max-w-[470px] benefits-policy-content-vs">
                  <h3 className="md:text-[18px] xl:text-[24px] text-[16px] font-semibold md:mb-2.5 mb-2 md:leading-[22px] xl:leading-[28px] leading-[20px] tracking-tight">
                    {translations.acceleratedDeathBenefitTitle}
                  </h3>
                  <p className="md:text-[10.5px] xl:text-[14px] text-[13px] md:leading-[16px] xl:leading-[20px] leading-[18px]">
                    {translations.acceleratedDeathBenefitDesc}
                  </p>
                </div>
              </div>
              <div className="flex reveal-up reveal-delay-3 benefits-policy-grid">
                <div className="pe-[1.8rem] flex-none">
                  <img src={AutomaticIcon} className="w-[84px]" alt="" />
                </div>
                <div className="max-w-[470px] benefits-policy-content-vs">
                  <h3 className="md:text-[18px] xl:text-[24px] text-[16px] font-semibold md:mb-2.5 mb-2 md:leading-[22px] xl:leading-[28px] leading-[20px] tracking-tight">
                    {translations.automaticBenefitRiderTitle}
                  </h3>
                  <p className="md:text-[10.5px] xl:text-[14px] text-[13px] md:leading-[16px] xl:leading-[20px] leading-[18px]">
                    {translations.automaticBenefitRiderDesc}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right image column — capsule extends past viewport per design */}
          <div className="w-full lg:w-3/5 hidden lg:block">
            <img
              src={coverImage}
              alt="Term life benefits"
              className="w-full lg:!max-w-none lg:w-[140%] [@media(min-width:1920px)]:w-[130%] h-auto object-cover reveal-up"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitSectionPlanPage2;
